const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: theme.spacing(4, 3),
    },
  },
  nameAndDescription: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  name: {
    marginBottom: theme.spacing(1),
  },
  description: {
    fontSize: '0.9rem',
    whiteSpace: 'pre-line',
    opacity: 0.8,
  },
  priceAndDeleteButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
  },
  priceBox: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'center',
      marginBottom: 0,
      marginRight: theme.spacing(2),
    },
  },
  price: {
    ...theme.typography.h2,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  pricePrefix: {
    color: 'inherit',
    fontSize: '1.3rem',
    fontWeight: 'inherit',
    marginRight: theme.spacing(1),
  },
  periodicity: {
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    opacity: 0.8,
  },
})

export default styles
